export default "__VITE_ASSET__CM$iIbCv__"